var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import parse from 'html-react-parser';
import FeatherIcon from 'feather-icons-react';
import { ArrowLeftDouble, ArrowRightDouble, Barcode, CancelCircle, CaretDown, CaretRight, CaretUp, CheckCircle2, CloseCircle, DragHorizontal, DragVertical, FlagBr, FlagEs, FlagUs, Help, ImagePlaceholder, InfoCircle, Pdf, Person, QrCode, Sort, TriangleDown, Whatsapp, X, Xls, } from '@gerdau/hefesto-assets/dist/assets/icons';
import './Icon.styles.scss';
var Icon = function (_a) {
    var variant = _a.variant, option = _a.option, _b = _a.size, size = _b === void 0 ? 'full' : _b;
    var ignoreFeatherIcon = [
        'ArrowLeftDouble',
        'ArrowRightDouble',
        'Barcode',
        'CancelCircle',
        'CaretDown',
        'CaretRight',
        'CaretUp',
        'CheckCircle2',
        'CloseCircle',
        'DragHorizontal',
        'DragVertical',
        'FlagBr',
        'FlagEs',
        'FlagUs',
        'Help',
        'ImagePlaceholder',
        'InfoCircle',
        'PDF',
        'Person',
        'QrCode',
        'Sort',
        'TriangleDown',
        'Whatsapp',
        'X',
        'XLS',
    ];
    function SelectIcon(icon) {
        var allowedIcons = {
            Alert: 'alert-triangle',
            ArrowDown: 'arrow-down',
            ArrowLeft: 'arrow-left',
            ArrowLeftDouble: parse(ArrowLeftDouble),
            ArrowRight: 'arrow-right',
            ArrowRightDouble: parse(ArrowRightDouble),
            ArrowUp: 'arrow-up',
            Attach: 'paperclip',
            Award: 'award',
            Barcode: parse(Barcode),
            Bell: 'bell',
            Calendar: 'calendar',
            Camera: 'camera',
            CancelCircle: parse(CancelCircle),
            CaretDown: parse(CaretDown),
            CaretRight: parse(CaretRight),
            CaretUp: parse(CaretUp),
            Cart: 'shopping-cart',
            Check: 'check',
            CheckCircle2: parse(CheckCircle2),
            CheckCircle: 'check-circle',
            ChevronDown: 'chevron-down',
            ChevronLeft: 'chevron-left',
            ChevronRight: 'chevron-right',
            ChevronUp: 'chevron-up',
            Clock: 'clock',
            CloseCircle: parse(CloseCircle),
            DollarSign: 'dollar-sign',
            Download: 'download',
            DragHorizontal: parse(DragHorizontal),
            DragVertical: parse(DragVertical),
            Edit: 'edit',
            Email: 'mail',
            Filter: 'filter',
            FlagBr: parse(FlagBr),
            FlagEs: parse(FlagEs),
            FlagUs: parse(FlagUs),
            Grid: 'grid',
            Help: parse(Help),
            HelpCircle: 'help-circle',
            Home: 'home',
            ImagePlaceholder: parse(ImagePlaceholder),
            Info: 'info',
            InfoCircle: parse(InfoCircle),
            List: 'list',
            Maximize: 'maximize-2',
            Menu: 'menu',
            Mic: 'mic',
            Minimize: 'minimize-2',
            Minus: 'minus',
            MinusCircle: 'minus-circle',
            MoreHorizontal: 'more-horizontal',
            MoreVertical: 'more-vertical',
            PDF: parse(Pdf),
            Person: parse(Person),
            Plus: 'plus',
            PlusCircle: 'plus-circle',
            Print: 'printer',
            QrCode: parse(QrCode),
            Refresh: 'refresh-cw',
            Save: 'save',
            Search: 'search',
            Settings: 'settings',
            Share: 'share',
            Sort: parse(Sort),
            Trash: 'trash-2',
            TriangleDown: parse(TriangleDown),
            Truck: 'truck',
            Upload: 'upload',
            Whatsapp: parse(Whatsapp),
            X: parse(X),
            XCircle: 'x-circle',
            XLS: parse(Xls),
        };
        var getClassName = function () {
            var classList = ['hefesto-icon', icon];
            if (variant) {
                classList.push("hefesto-icon--".concat(variant));
            }
            if (size) {
                classList.push("hefesto-icon--".concat(size));
            }
            return classList.join(' ');
        };
        var className = getClassName();
        return (_jsx("span", __assign({ className: className, tabIndex: -1, "data-testid": "hefesto-icon" }, { children: ignoreFeatherIcon.includes(option) ? (allowedIcons[icon]) : (_jsx(FeatherIcon, { icon: allowedIcons[icon] })) })));
    }
    return SelectIcon(option);
};
export default Icon;
